<!-- todo - replace with circular shared component button -->
<template>
  <div class="nav-button">
    <Button
      :icon="icon"
      @click="disabled ? '' : $emit('click', $event)"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { Button } from '@neurotrack/web-shared-components'

export default {
  name: 'NavButton',
  components: { Button },
  props: {
    direction: {
      type: String,
      default: 'next'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      return this.direction === 'next'
        ? 'mdi-chevron-right'
        : 'mdi-chevron-left'
    }
  }
}
</script>

<style scoped>
.nav-button {
  flex-basis: 7.5rem;
  display: flex;
  justify-content: center;
}
</style>
